import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';

/**
 * Where this app is mounted, matching the build's `base`.
 *
 * The three apps share one domain, so the driver build sits under a path
 * prefix. Without this the router would treat that prefix as part of every
 * route and match none of them.
 */
const BASE_PATH = import.meta.env.BASE_URL.replace(/\/$/, '') || '/';
import { queryClient } from '../lib/queryClient';
import '../i18n';

/** Everything the tree needs: data cache, routing and translations. */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={BASE_PATH}>{children}</BrowserRouter>
    </QueryClientProvider>
  );
}
